// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__rTjdG","calendarButtons":"ClockData_calendarButtons__3ZP7V"};